import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Usuario } from '../../_classes/usuario';
import { LoginService } from '../../services/login.service';
import { LoadingService } from '../../services/loading.service';
import { UserSessionService } from '../../services/user-session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  usuario: Usuario;
  erro = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private loadingService: LoadingService,
    private userSession: UserSessionService
  ) { }

  ngOnInit() {
    this.initUsuario();
  }

  initUsuario() {
    this.usuario = new Usuario();
  }

  login() {
    this.loadingService.changeLoading(true);
    this.loginService.login(this.usuario).subscribe(result => {
      this.loadingService.changeLoading(false);
      this.userSession.changeUser(true);
      localStorage.setItem('user', JSON.stringify(result.body));
      localStorage.setItem('access_token', result.headers.get('Authorization'));
      this.router.navigate(['/dashboard']);
    }, error => {
      this.erro = true;
      this.loadingService.changeLoading(false);
      this.userSession.changeUser(false);
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts